import { ROUTES } from "@/lib/navigation";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import LayoutContainer from "./LayoutContainer";
import stylReLogo from "@/assets/stylere-logo.png";

export default function Footer() {
  return (
    <footer className="bottom-0 right-0 w-screen bg-[#111827]">
      <LayoutContainer className="max-w-6xl">
        <div className="grid gap-8 py-8 text-center md:grid-cols-[1.2fr_2fr_auto] md:text-left">
          <div className="flex flex-col space-y-3 justify-center items-center md:items-start">
            <img
              className="max-w-[175px]"
              src={stylReLogo}
              alt="Style.re Logo"
            />
            <p className="max-w-xs text-sm leading-6 text-gray-300">
              The fastest way to get fashion from your favorite stores to your door.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-2 w-full md:w-auto items-center md:items-start">
            <div className="flex flex-row justify-center md:justify-start gap-12 flex-wrap">
              <div>
                <h3 className="font-bold text-md mb-2 text-primary">
                  Resources
                </h3>
                <ul className="space-y-1 text-md text-gray-300">
                  <li>
                    <Link
                      to="/platform-services"
                    className="hover:text-white transition-colors cursor-pointer"
                    >
                      Platform Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/delivery-info"
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      Delivery Information
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/help-center"
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      Help Center
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-md mb-2 text-primary">About</h3>
                <ul className="space-y-1 text-md text-gray-300">
                  <li>
                    <Link
                      to="/about-us"
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/how-it-works"
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      How It Works
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/team"
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      Team
                    </Link>
                  </li>
                </ul>
              </div>

              {/* API section */}
              <div>
                <h3 className="font-bold text-md mb-2 text-primary">
                  Services
                </h3>
                <ul className="space-y-1 text-md text-gray-300">
                  <li>
                    <Link
                      to={ROUTES.API_LANDING}
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      Style.re API
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={ROUTES.ROBOT_LEASING}
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      Robot Leasing
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Socials */}
          <div className="flex justify-center items-center w-[175px] gap-x-2">
            <a
              href="https://www.instagram.com/_style.re/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex justify-center items-center w-10 h-10 group rounded-full hover:bg-primary/90 transition-colors duration-300"
            >
              <Instagram
                strokeWidth={1}
                className="w-full text-white group-hover:text-white transition-colors duration-300"
              />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61554334604723"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="flex justify-center items-center w-10 h-10 group px-2 rounded-full hover:bg-primary/90 transition-colors duration-300"
            >
              <Facebook
                strokeWidth={1}
                className="w-full text-white group-hover:text-white transition-colors duration-300"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/stylere/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex justify-center items-center w-10 h-10 group px-2 rounded-full hover:bg-primary/90 transition-colors duration-300"
            >
              <Linkedin
                strokeWidth={1}
                className="w-full text-white group-hover:text-white transition-colors duration-300"
              />
            </a>
          </div>
        </div>

				{/* Legal Links */}
				<div className="flex flex-col justify-center items-center">
					<div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-md text-gray-500">
						<Link
							to="/terms-and-conditions"
							className="hover:text-white transition-colors cursor-pointer"
						>
							Terms & Conditions
						</Link>
						<Link
							to="/privacy-policy"
							className="hover:text-white transition-colors cursor-pointer"
						>
							Privacy Policy
						</Link>
						<Link
							to="/accessibility"
							className="hover:text-white transition-colors cursor-pointer"
						>
							Accessibility
						</Link>
					</div>
					<p className="text-sm text-gray-300 my-2">
						&copy; {new Date().getFullYear()} Style.re. All rights
						reserved.
					</p>
				</div>
			</LayoutContainer>
		</footer>
	)
}
